import * as WebSocketRequest from "./ws-requests";

const bind = function () {
    const $orderCommentForm = $('#orderCommentForm');
    $orderCommentForm.find('textarea').on('focusout', function (e) {
        WebSocketRequest.customWebSocketAction({[$(this).attr('name')]: $(this).val()}, $orderCommentForm.data('ws'));
    });
};

export {
    bind,
}